import $ from 'jquery';

$(function() {
    var subContactsData = null;
    $(".cwm-addsub-contacts").hide();
    
    $("a.subcontact").click(function(){
        $(".cwm-addsub-contacts").show();
        $('html,body').animate({
            scrollTop: $(".cwm-addsub-contacts").offset().top - 200},
            '2000');
      });
    

   
    // close button 
	$("#cwm-addsubcontacts-Close" ).on( "click", function() { 
		$(".cwm-addsub-contacts").animate({height: "auto"}, function() {
			$(this).hide();
            window.location.reload();
		});	
	});
    // enable and disable submit button
    $('#cwm_addsub_contactsform input.my-account_formControl').on('keyup',function() {
        if ($('#cwm_asc_mfirstName').val() != '' || $('#cwm_asc_msurName').val() != '' ||
        $('#cwm_asc_Cname').val() != '' || $('#cwm_asc_Jtitle').val() != '' ||
        $('#cwm_asc_Sdob').val() != '' || $('#cwm_asc_SemailAddress').val() != '' ||
        $('#cwm_asc_phnumber').val() != '' ) {
            $('#cwmAddSubcontacts-submit').attr('disabled' , false);
        }else{
            $('#cwmAddSubcontacts-submit').attr('disabled' , true);
        }
    });
    //numbers not allowing
    $("#cwm_asc_mfirstName").keypress(function(e) {
		var numbers = ['0','1','2','3','4','5','6','7','8','9'];
		var keynum;	  
		if (window.event) { // IE                    
		  keynum = e.keyCode;
		} else if (e.which) { // Netscape/Firefox/Opera                   
		  keynum = e.which;
		}	  
		if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
		  e.preventDefault();
		}
	  });
      $("#cwm_asc_msurName").keypress(function(e) {
		var numbers = ['0','1','2','3','4','5','6','7','8','9'];
		var keynum;	  
		if (window.event) { // IE                    
		  keynum = e.keyCode;
		} else if (e.which) { // Netscape/Firefox/Opera                   
		  keynum = e.which;
		}	  
		if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
		  e.preventDefault();
		}
	  });
    //Edit SubContacts details form: ajax request
	$('#cwmAddSubcontacts-submit').on( "click", function() {
        // assigning form values and names in to var
		subContactsData = {
			FirstName: { FieldName: "FirstName", FieldValue: $("#cwm_asc_mfirstName").val() },
			SurName: { FieldName: "SurName", FieldValue: $("#cwm_asc_msurName").val() },
			CompanyName: { FieldName: "CompanyName", FieldValue: $("#cwm_asc_Cname").val() },
			JobTitle: { FieldName: "JobTitle", FieldValue: $("#cwm_asc_Jtitle").val() },
			DateOfBirth: { FieldName: "DateOfBirth", FieldValue: $("#cwm_asc_Sdob").val() },
			SubContactEmail: { FieldName: "SubContactEmail", FieldValue: $("#cwm_asc_SemailAddress").val() },
			PhoneNumber: { FieldName: "PhoneNumber", FieldValue: $("#cwm_asc_phnumber").val() }		
		}
        
        //only accept letters /^[a-zA-Z\s]*$/
		$.validator.addMethod("letters", function(value, element) {
			return this.optional(element) || value == value.match(/[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+'?[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+/g);
		});
        //onlynumbers and Phone number(/^[0-9 -.\s]+$/)
		$.validator.addMethod("telnumber", function(value, element) {
			return this.optional(element) || value == value.match(/^[0-9 + ]+$/);
		});
        //onlynumbers and Uppercase letters
		$.validator.addMethod("fanNumber", function(value, element) {
			return this.optional(element) || value == value.match(/^[0-9\s]*$/);
		});
        //Date dd/mm/yyyy validation
		$.validator.addMethod(
			"subCvalidDate",
			function(value, element) {
				return value.match(/(?:0[1-9]|[12][0-9]|3[01])\/(?:0[1-9]|1[0-2])\/(?:19\d{2}|20\d{2})/);
			},
		);
		//validation for 18 years old
		$.validator.addMethod(
			"subCvalidDOB",
			function(value, element) {              
				var from = value.split("/"); // DD/MM/YYYY
				var day = from[0];
				var month = from[1];
				var year = from[2];
				var age = 18;
				var mydate = new Date();
				mydate.setFullYear(year, month-1, day);		
				var currdate = new Date();
				var setDate = new Date();
	
				setDate.setFullYear(mydate.getFullYear() + age, month-1, day);
	
				if ((currdate - setDate) > 0){
					return true;
				}else{
					return false;
				}
			},
		);
        $("#cwm_addsub_contactsform").validate({ 
            wrapper: 'span',
            errorPlacement: function (error, element) {
				error.addClass("my-account_errorlabel")
				error.insertAfter(element);
			},
            rules: {
                cwm_asc_mfirstName: {
                    required: true,
                    maxlength: 255,
					letters: true
                },
                cwm_asc_msurName: {
                    required: true,
                    maxlength: 255,
					letters: true
                },
                cwm_asc_Cname: {
                    maxlength: 255,
                },
                cwm_asc_Jtitle: {
                   maxlength: 255
                },
                cwm_asc_Sdob: {
                    required: true,
                    subCvalidDate: true,  
					subCvalidDOB: true
                },
                cwm_asc_SemailAddress: {
                    required: true,
                    email: true
                },
                cwm_asc_phnumber: {
                    telnumber: true,
                    required: true,
					maxlength: 18
                }                
            },
            messages: {  
                cwm_asc_mfirstName: {
                    required: "Please enter firstname.",
                    letters: "Please enter text only.",
					maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_msurName: {
                    required: "Please enter surname.",
					letters: "Please enter text only.",
					maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_Cname: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_Jtitle: {
                   maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_Sdob: {
                    required: "Please enter your DOB in the format DD/MM/YYYY.",
                    subCvalidDOB: "You must be age 18 or over.",
					subCvalidDate: "Please enter your DOB in the format DD/MM/YYYY."
                },
                cwm_asc_SemailAddress: {
                    required: "Please enter email address.",
                    email: "Please enter a valid email address."
                },
                cwm_asc_phnumber: {
                    telnumber: "Please enter a valid phone number.",
                    required: "Please enter a phone number.",
					maxlength: "Please enter no more than 15 numbers."
                }
            },

            submitHandler: function(form) { 
                $('html').css({ 'overflow-y': "hidden" });
				$("#cwm-overlay").show();
				$.ajax({
					url: form.action,
                    type: form.method,
                    data: subContactsData,
                    dataType: "json",
                    success: function (response) {  
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
                        $("#cwm_addcontact_form").hide();
						$('#subContact-success-message').show();
                        console.log(JSON.stringify(subContactsData));
                        $('html,body').animate({
							scrollTop: $("#subContact-success-message").offset().top - 100},'1000');
                    },
                    error: function (response) {
                        $('html').css({ 'overflow-y': "scroll" });
						$("#cwm-overlay").hide();
                        console.log(response.error);  
                    }        
				});
			}
        })
    });
});


// WEBPACK FOOTER //
// ./components/cwm-addsubcontacts-form/scripts/cwm-addsubcontacts-form.js